import { AxisBottom, AxisScale } from "@visx/axis"

import { Group } from "@visx/group"

export type XAxisProps = {
  scale: AxisScale
  top: number
}

export default function XAxis({ scale, top }: XAxisProps) {
  return (
    <AxisBottom
      top={top}
      scale={scale}
      tickLabelProps={() => ({
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        letterSpacing: " 0.4px",
        textAnchor: "middle",
      })}
    >
      {(props) => {
        const tickLabelSize = 12
        const tickColor = "white"
        return (
          <g>
            {props.ticks.map((tick, i) => {
              const tickX = tick.to.x
              const tickY = tick.to.y + tickLabelSize

              return (
                <Group key={`vx-tick-${tick.value}-${i}`}>
                  <text
                    transform={`translate(${tickX}, ${tickY})`}
                    fontSize={tickLabelSize}
                    textAnchor="middle"
                    fill={tickColor}
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    <tspan dy="26.5" x="0">
                      {tick.formattedValue}
                    </tspan>
                  </text>
                </Group>
              )
            })}
          </g>
        )
      }}
    </AxisBottom>
  )
}
